import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { useForm } from '@/fo/ui/mod/form/base';

import {
  AboutProductSection,
  AboutUserSection,
  FormFooter,
  SuccessMessage,
  RatingField,
  RatingValue
} from '../../components';
// import { UserInfo } from '../../types';

import { formAction } from './formAction';
import { styles } from './ReviewForm.styles';

export interface ReviewFormProps {
  ratingId: string;
  ratings: RatingValue[];
  sku: string;
  onSuccess?: () => void;
  // userInfo?: UserInfo;
  onClose?: () => void;
}

export function ReviewForm({
  ratingId,
  ratings,
  sku,
  onSuccess,
  // userInfo,
  onClose
}: ReviewFormProps) {
  const slots = styles();

  const t = useTranslations('review.form');

  const { getFieldProps, pending, isDirty, state, action } =
    useForm(formAction);

  // const [photoLoading, setPhotoLoading] = useState(false);

  const isSuccess = state.status === 'success';

  useEffect(() => {
    if (isSuccess) {
      onSuccess?.();
    }
  }, [isSuccess, onSuccess]);

  if (isSuccess) {
    return <SuccessMessage onClick={onClose} />;
  }

  return (
    <form
      className={slots.base()}
      noValidate
      action={action}
    >
      <input
        type="hidden"
        name="sku"
        value={sku}
      />
      <div className={slots.formContainer()}>
        <RatingField
          ratings={ratings}
          ratingId={ratingId}
          {...getFieldProps('rating')}
        />

        <div>
          <h3 className={slots.formTitle()}>{t('aboutUser.title')}</h3>
          <AboutUserSection getFieldProps={getFieldProps} />
        </div>

        <div>
          <h3 className={slots.formTitle()}>{t('aboutProduct.title')}</h3>
          <AboutProductSection getFieldProps={getFieldProps} />
        </div>
      </div>
      <FormFooter
        pending={pending}
        isDirty={isDirty}
      />
    </form>
  );
}
